import { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./range.css";


const Counter = ({ target, duration, startCount }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!startCount) return; 

    let start = 0;
    const end = target;
    const increment = Math.ceil(end / (duration / 10)); 

    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(start);
      }
    }, 10);

    return () => clearInterval(timer);
  }, [target, duration, startCount]);

  return <h2 className="count">{count}+</h2>;
};


const CounterSection = () => {
  const [startCount, setStartCount] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setStartCount(true);
          observer.disconnect(); 
        }
      },
      { threshold: 0.5 } 
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <>
    
      <section ref={sectionRef} className="range position-relative py-5">
          <div className="container">
           <div className="position-relative heading-container mx-auto">
          <h2 className="heading">
            O<span className="heading-span ">UR</span> S<span className="heading-span ">TRENGTHS</span>
               </h2>
          <div className="line products-line"></div>
        </div>
                
                <div className="row ">
                
                          <div className="col-sm-6 text-center col-lg-3 py-5 ">
                    <Counter target={10} duration={2000} startCount={startCount} />
                    <p className="range-text  pt-4">Years Experience</p>
                  </div>
                  <div className="col-sm-6 text-center col-lg-3 py-5">
                    <Counter target={19} duration={2000} startCount={startCount} />
                    <p className="range-text  pt-4">Product Range</p>
                  </div>
                  <div className="col-sm-6 text-center col-lg-3 py-5">
                    <Counter target={35} duration={2000} startCount={startCount} />
                    <p className="range-text  pt-4">Team Size</p>
                  </div>
                   <div className="col-sm-6 text-center col-lg-3 py-5">
                    <Counter target={500} duration={2000} startCount={startCount} />
                    <p className="range-text  pt-4">Clients</p>
                  </div>
                    </div>
                </div>
               
            
            <div className="ball ball1"></div>
            <div className="ball ball2"></div>
       
      </section>
    </>
  );
};

export default CounterSection;
